import { useContext, createContext, ReactNode } from "react";
import api from "~/services/api";
// Interfaces
import {
    UnitsState, EnergiesState,
    PricesState, OthersState,
    IcmsState,
    LostEnergyState, TeAclState,
    PisCofinState
} from './interfaces'

// Contexts
import { GeneralContext } from '~/contexts';


interface UnitsContextData {
    save                : Function;
    remove              : Function;
    saveGlobalLostEnergy: Function;
    saveEnergies        : Function;
    savePrices          : Function;
    savePisCofins       : Function;
    saveOthers          : Function;
    saveIcms            : Function;
    deletePrices        : Function;
    saveLostEnergy      : Function;
    saveTeAcl           : Function;
    deletePisCofins     : Function;
    deleteTeAcl         : Function;
}

interface UnitsProviderProps {
    children: ReactNode;
}

export const UnitsContext = createContext({} as UnitsContextData)

export function UnitsProvider ({ children }: UnitsProviderProps) {
    const {user} = useContext(GeneralContext);

    // Unit Functions
    async function save(unitData: UnitsState, Modal: any, setReady: Function) {
        api.post('clients', unitData, {
            headers: { Authorization: user.token }
        }).then(resp => {
            if (Modal?.setModalMessage) {
                Modal.setModalMessage('Unidade salva com sucesso');
                setTimeout(() => Modal.setModalMessage(''), 2000);
            }
            setTimeout(() => {
                Modal.setModalOpen(false);
                setReady(false);
            }, 1200);
        }).catch(err => {
            if (Modal?.setModalMessage) {
                Modal.setModalMessage('Erro ao salvar unidade');
                setTimeout(() => Modal.setModalMessage(''), 2000);
            }
            throw err;
        });
    }

    async function remove (id: number, Modal: any, setReady: Function) {
        api.delete(`clients/${id}`, {
            headers: { Authorization: user.token }
        }).then(resp => {
            Modal.setModalOpen(false);
            setReady(false);
        }).catch(err => {
            const { status } = err.response;

            if (status===400) {
                const error = err.response.data.errors;
                console.log(error);
            }
        });
    }

    async function deletePisCofins (id_pis_cofins: number) {
        api.delete(`clients/pisCofins/${id_pis_cofins}`, {
            headers: { Authorization: user.token }
        }).then(resp => {
            return resp;
        }).catch(err => {
            const { status } = err.response;
            if (status===400) {
                const error = err.response.data.errors;
                console.log(error);
            }
        });
    }

    async function deleteTeAcl (payload: any) {

        api.delete(`clients/teAcl/${payload.id}`, {
            headers: { Authorization: user.token }
        }).then(resp => {
            return resp;
        }).catch(err => {
            throw err;
        });
    }

    async function deletePrices (id_prices: number) {
        api.delete(`clients/prices/${id_prices}`, {
            headers: { Authorization: user.token }
        }).then(resp => {
            return resp;
        }).catch(err => {
            throw err;
        });
    }

    async function saveGlobalLostEnergy (lostEnergy: any, setLostEnergy: Function, setLostEnergyEdit: Function) {
        setLostEnergyEdit(true);
        let data = { ...lostEnergy, value: (lostEnergy.value ? parseFloat(lostEnergy.value) : 0)};

        api.post('clients/lost_energy', data, {
            headers: { Authorization: user.token }
        }).then(resp => {
            setLostEnergy(resp.data);
            setTimeout(() => setLostEnergyEdit(false), 1000);
        }).catch(err => {
            const { status } = err.response;

            if (status===400) {
                const error = err.response.data.errors;
                console.log(error);
            }
        });
    }

    // Others Functions
    async function saveEnergies (id: number, data: EnergiesState[], Modal: any, setReady: Function) {
        const energiesData = data.length>0 ? data : { id };

        let toCheckValueDate = verifyDuplicatesDate(data)

        if(toCheckValueDate.length > 0){
            Modal.setModalMessage(toCheckValueDate[0])
            setTimeout(()=> Modal.setModalMessage('')
            , 2000);
        }else{
            api.post('clients/energies', energiesData, {
                headers: { Authorization: user.token }
            }).then(resp => {
                Modal.setModalOpen(false);
                setReady(false);
            }).catch(err => {
                const { status } = err.response;

                if (status===400) {
                    const error = err.response.data.errors;
                    console.log(error);
                }
            });
        }
    }

    async function savePrices (data: PricesState[]) {
       
        api.post('clients/prices', data, {
            headers: { Authorization: user.token }
        }).then(resp => {
            return resp;
        }).catch(err => {
            const { status } = err.response;

            if (status===400) {
                const error = err.response.data.errors;
                console.log(error);
            }
        });
      
    }

    async function savePisCofins (id: number, data: PisCofinState[], Modal: any, setReady: Function) {

        api.post('clients/pisCofins', data, {
            headers: { Authorization: user.token }
        }).then(resp => {
            return resp.data;
        }).catch(err => {
            throw err;  
        });
           
            
    }

    async function saveOthers (id: number, data: OthersState[], Modal: any, setReady: Function) {
        const othersData = data.length>0 ? data : { id };

        let toCheckValueDate = verifyDuplicatesDate(data)

        if(toCheckValueDate.length > 0){
            Modal.setModalMessage(toCheckValueDate[0])
            setTimeout(()=> Modal.setModalMessage('')
            , 2000);
        }else{
        api.post('clients/others', othersData, {
            headers: { Authorization: user.token }
        }).then(resp => {
            Modal.setModalOpen(false);
            setReady(false);
        }).catch(err => {
            const { status } = err.response;

            if (status===400) {
                const error = err.response.data.errors;
                console.log(error);
            }
        });
      }
    }

    async function saveIcms (id: number, data: IcmsState[], Modal: any, setReady: Function) {
        const icmsData = data.length>0 ? data : { id };

        let toCheckValueDate = verifyDuplicatesDate(data)

        if(toCheckValueDate.length > 0){
            Modal.setModalMessage(toCheckValueDate[0])
            setTimeout(()=> Modal.setModalMessage('')
            , 2000);
        }else{
        api.post('clients/icms', icmsData, {
            headers: { Authorization: user.token }
        }).then(resp => {
            return resp.data;
        }).catch(err => {
            const { status } = err.response;

            if (status===400) {
                const error = err.response.data.errors;
                console.log(error);
            }
        });
      }
    }

    async function saveLostEnergy (id: number, data: LostEnergyState[], Modal: any, setReady: Function) {
        const lostEnergyData = data.length>0 ? data : { id };

        let toCheckValueDate = verifyDuplicatesDate(data)

        if(toCheckValueDate.length > 0){
            Modal.setModalMessage(toCheckValueDate[0])
            setTimeout(()=> Modal.setModalMessage('')
            , 2000);
        }else{
        api.post('clients/lost_energy', lostEnergyData, {
            headers: { Authorization: user.token }
        }).then(resp => {
            return resp.data;
        }).catch(err => {
            const { status } = err.response;

            if (status===400) {
                const error = err.response.data.errors;
                console.log(error);
            }
        });
      }
    }

    async function saveTeAcl (data: TeAclState) {

        api.post('clients/teAcl', data, {
            headers: { Authorization: user.token }
        }).then(resp => {
            return resp.data;
        }).catch(err => {
            const { status } = err.response;

            if (status===400) {
                const error = err.response.data.errors;
                console.log(error);
            }
        });
      
    }

    function verifyDuplicatesDate(dados: any) {
        let anos: number[] = [];
        let anosMeses: string[] = [];
        let erros: string[] = [];

        dados.forEach((item: any) => {
            let { year, month } = item;

            if (typeof year === 'string') {
                year = parseInt(year);
            }

            if (month === 0) {
                if (anos.indexOf(year) !== -1) {
                    erros.push(`Dados duplicado encontrado: Ano: ${year}, Mês: Geral`);
                } else {
                    anos.push(year);
                }
            } else {
                let anoMes = `${year}-${month}`;
                if (anosMeses.indexOf(anoMes) !== -1) {
                    erros.push(`Dados duplicado encontrado: Ano: ${year}, Mês: ${month}`);
                } else {
                    anosMeses.push(anoMes);
                }
            }
        });
        return erros;
    }

    return (
        <UnitsContext.Provider value={{
            save, remove,
            saveGlobalLostEnergy,
            saveEnergies, savePrices, savePisCofins,
            saveOthers,
            saveIcms, saveLostEnergy, saveTeAcl, deletePisCofins, deletePrices, deleteTeAcl
        }}>
            { children }
        </UnitsContext.Provider>
    )
}